export const comments_3294066 = {"data":{"data":[],"links":{}}}